import { Task } from '@/types/employee/task';
import dayjs from 'dayjs';

export const tasks: Task[] = [
  {
    id: 'TASK001',
    title: 'Reparar grifo con fugas en Unidad 101',
    description: 'Residente reportó un grifo con fugas en el baño',
    type: 'maintenance',
    status: 'in_progress',
    priority: 'high',
    assignedTo: {
      id: 'EMP001',
      name: 'Miguel Johnson'
    },
    assignedBy: {
      id: 'ADM001',
      name: 'Juan Smith'
    },
    dueDate: dayjs('2024-03-20').toDate(),
    apartmentUnit: {
      id: 'UNIT001',
      name: 'Unidad 101'
    },
    attachments: [
      {
        id: 'ATT001',
        name: 'Foto de Fuga',
        type: 'image/jpeg',
        size: 1024,
        path: '/documents/tasks/TASK001/leak.jpg',
        url: '/documents/tasks/TASK001/leak.jpg',
        uploadedAt: dayjs('2024-03-15').toDate()
      }
    ],
    workspace: {
      id: 'WS001',
      name: 'Apartamentos Sunset',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'TASK002',
    title: 'Limpiar lobby de área común',
    description: 'Limpieza diaria del área principal del lobby',
    type: 'cleaning',
    status: 'completed',
    priority: 'medium',
    assignedTo: {
      id: 'EMP002',
      name: 'Sara Wilson'
    },
    assignedBy: {
      id: 'ADM001',
      name: 'Juan Smith'
    },
    dueDate: dayjs('2024-03-19').toDate(),
    completedAt: dayjs('2024-03-19').toDate(),
    workspace: {
      id: 'WS001',
      name: 'Apartamentos Sunset',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'TASK003',
    title: 'Patrulla de seguridad - Edificio A',
    description: 'Patrulla de seguridad nocturna alrededor del perímetro del Edificio A',
    type: 'security',
    status: 'pending',
    priority: 'high',
    assignedTo: {
      id: 'EMP003',
      name: 'David Brown'
    },
    assignedBy: {
      id: 'ADM002',
      name: 'Lisa Davis'
    },
    dueDate: dayjs('2024-03-21').toDate(),
    workspace: {
      id: 'WS001',
      name: 'Apartamentos Sunset',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'TASK004',
    title: 'Inspeccionar extintores de incendio',
    description: 'Inspección mensual de todos los extintores de incendio en el edificio',
    type: 'inspection',
    status: 'in_progress',
    priority: 'urgent',
    assignedTo: {
      id: 'EMP004',
      name: 'Roberto Taylor'
    },
    assignedBy: {
      id: 'ADM001',
      name: 'Juan Smith'
    },
    dueDate: dayjs('2024-03-18').toDate(),
    workspace: {
      id: 'WS001',
      name: 'Apartamentos Sunset',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'TASK005',
    title: 'Reemplazar bombillas - Garaje de estacionamiento',
    description: 'Reemplazar bombillas quemadas en el garaje de estacionamiento',
    type: 'maintenance',
    status: 'completed',
    priority: 'medium',
    assignedTo: {
      id: 'EMP001',
      name: 'Miguel Johnson'
    },
    assignedBy: {
      id: 'ADM002',
      name: 'Lisa Davis'
    },
    dueDate: dayjs('2024-03-17').toDate(),
    completedAt: dayjs('2024-03-17').toDate(),
    workspace: {
      id: 'WS001',
      name: 'Apartamentos Sunset',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'TASK006',
    title: 'Limpiar área de piscina',
    description: 'Limpieza semanal de la piscina y área circundante',
    type: 'cleaning',
    status: 'pending',
    priority: 'low',
    assignedTo: {
      id: 'EMP005',
      name: 'María García'
    },
    assignedBy: {
      id: 'ADM001',
      name: 'Juan Smith'
    },
    dueDate: dayjs('2024-03-22').toDate(),
    workspace: {
      id: 'WS001',
      name: 'Apartamentos Sunset',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'TASK007',
    title: 'Verificar sistema HVAC - Unidad 205',
    description: 'Residente reportó que el aire acondicionado no funciona correctamente',
    type: 'maintenance',
    status: 'in_progress',
    priority: 'high',
    assignedTo: {
      id: 'EMP006',
      name: 'Jaime Wilson'
    },
    assignedBy: {
      id: 'ADM002',
      name: 'Lisa Davis'
    },
    dueDate: dayjs('2024-03-20').toDate(),
    apartmentUnit: {
      id: 'UNIT205',
      name: 'Unidad 205'
    },
    workspace: {
      id: 'WS001',
      name: 'Apartamentos Sunset',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'TASK008',
    title: 'Mantenimiento de cámaras de seguridad',
    description: 'Verificar y limpiar todas las cámaras de seguridad en el edificio',
    type: 'security',
    status: 'completed',
    priority: 'medium',
    assignedTo: {
      id: 'EMP003',
      name: 'David Brown'
    },
    assignedBy: {
      id: 'ADM001',
      name: 'Juan Smith'
    },
    dueDate: dayjs('2024-03-16').toDate(),
    completedAt: dayjs('2024-03-16').toDate(),
    workspace: {
      id: 'WS001',
      name: 'Apartamentos Sunset',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'TASK009',
    title: 'Inspeccionar sistemas de ascensor',
    description: 'Inspección mensual de seguridad del ascensor y mantenimiento',
    type: 'inspection',
    status: 'pending',
    priority: 'urgent',
    assignedTo: {
      id: 'EMP004',
      name: 'Roberto Taylor'
    },
    assignedBy: {
      id: 'ADM002',
      name: 'Lisa Davis'
    },
    dueDate: dayjs('2024-03-23').toDate(),
    workspace: {
      id: 'WS001',
      name: 'Apartamentos Sunset',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'TASK010',
    title: 'Limpiar equipos de gimnasio',
    description: 'Limpieza diaria y sanitización de equipos de gimnasio',
    type: 'cleaning',
    status: 'completed',
    priority: 'low',
    assignedTo: {
      id: 'EMP002',
      name: 'Sara Wilson'
    },
    assignedBy: {
      id: 'ADM001',
      name: 'Juan Smith'
    },
    dueDate: dayjs('2024-03-19').toDate(),
    completedAt: dayjs('2024-03-19').toDate(),
    workspace: {
      id: 'WS001',
      name: 'Apartamentos Sunset',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'TASK011',
    title: 'Reparar ventana rota - Unidad 312',
    description: 'Residente reportó una ventana agrietada en la sala de estar',
    type: 'maintenance',
    status: 'pending',
    priority: 'medium',
    assignedTo: {
      id: 'EMP001',
      name: 'Miguel Johnson'
    },
    assignedBy: {
      id: 'ADM002',
      name: 'Lisa Davis'
    },
    dueDate: dayjs('2024-03-24').toDate(),
    apartmentUnit: {
      id: 'UNIT312',
      name: 'Unidad 312'
    },
    workspace: {
      id: 'WS001',
      name: 'Apartamentos Sunset',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'TASK012',
    title: 'Patrulla de seguridad nocturna',
    description: 'Patrulla de seguridad durante la noche de toda la propiedad',
    type: 'security',
    status: 'in_progress',
    priority: 'high',
    assignedTo: {
      id: 'EMP007',
      name: 'Tomás Anderson'
    },
    assignedBy: {
      id: 'ADM001',
      name: 'Juan Smith'
    },
    dueDate: dayjs('2024-03-20').toDate(),
    workspace: {
      id: 'WS001',
      name: 'Apartamentos Sunset',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'TASK013',
    title: 'Inspeccionar paneles eléctricos',
    description: 'Inspección trimestral de todos los paneles eléctricos y circuitos',
    type: 'inspection',
    status: 'completed',
    priority: 'urgent',
    assignedTo: {
      id: 'EMP004',
      name: 'Roberto Taylor'
    },
    assignedBy: {
      id: 'ADM002',
      name: 'Lisa Davis'
    },
    dueDate: dayjs('2024-03-15').toDate(),
    completedAt: dayjs('2024-03-15').toDate(),
    workspace: {
      id: 'WS001',
      name: 'Apartamentos Sunset',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'TASK014',
    title: 'Limpiar sala de lavandería',
    description: 'Limpieza semanal de la sala de lavandería compartida',
    type: 'cleaning',
    status: 'pending',
    priority: 'low',
    assignedTo: {
      id: 'EMP005',
      name: 'María García'
    },
    assignedBy: {
      id: 'ADM001',
      name: 'Juan Smith'
    },
    dueDate: dayjs('2024-03-25').toDate(),
    workspace: {
      id: 'WS001',
      name: 'Apartamentos Sunset',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'TASK015',
    title: 'Reparar puerta de garaje',
    description: 'Arreglar puerta de garaje defectuosa en área de estacionamiento',
    type: 'maintenance',
    status: 'in_progress',
    priority: 'high',
    assignedTo: {
      id: 'EMP006',
      name: 'Jaime Wilson'
    },
    assignedBy: {
      id: 'ADM002',
      name: 'Lisa Davis'
    },
    dueDate: dayjs('2024-03-21').toDate(),
    workspace: {
      id: 'WS001',
      name: 'Apartamentos Sunset',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'TASK016',
    title: 'Mantenimiento de puerta de seguridad',
    description: 'Verificar y reparar la puerta de seguridad principal',
    type: 'security',
    status: 'completed',
    priority: 'medium',
    assignedTo: {
      id: 'EMP003',
      name: 'David Brown'
    },
    assignedBy: {
      id: 'ADM001',
      name: 'Juan Smith'
    },
    dueDate: dayjs('2024-03-18').toDate(),
    completedAt: dayjs('2024-03-18').toDate(),
    workspace: {
      id: 'WS001',
      name: 'Apartamentos Sunset',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'TASK017',
    title: 'Inspeccionar sistemas de plomería',
    description: 'Inspección anual de todos los sistemas de plomería',
    type: 'inspection',
    status: 'pending',
    priority: 'medium',
    assignedTo: {
      id: 'EMP004',
      name: 'Roberto Taylor'
    },
    assignedBy: {
      id: 'ADM002',
      name: 'Lisa Davis'
    },
    dueDate: dayjs('2024-03-26').toDate(),
    workspace: {
      id: 'WS001',
      name: 'Apartamentos Sunset',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'TASK018',
    title: 'Limpiar sala comunitaria',
    description: 'Limpieza diaria de la sala de reuniones comunitaria',
    type: 'cleaning',
    status: 'completed',
    priority: 'low',
    assignedTo: {
      id: 'EMP002',
      name: 'Sara Wilson'
    },
    assignedBy: {
      id: 'ADM001',
      name: 'Juan Smith'
    },
    dueDate: dayjs('2024-03-19').toDate(),
    completedAt: dayjs('2024-03-19').toDate(),
    workspace: {
      id: 'WS001',
      name: 'Apartamentos Sunset',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'TASK019',
    title: 'Reparar barandilla de balcón - Unidad 408',
    description: 'Residente reportó barandilla de balcón suelta',
    type: 'maintenance',
    status: 'pending',
    priority: 'high',
    assignedTo: {
      id: 'EMP001',
      name: 'Miguel Johnson'
    },
    assignedBy: {
      id: 'ADM002',
      name: 'Lisa Davis'
    },
    dueDate: dayjs('2024-03-22').toDate(),
    apartmentUnit: {
      id: 'UNIT408',
      name: 'Unidad 408'
    },
    workspace: {
      id: 'WS001',
      name: 'Apartamentos Sunset',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'TASK020',
    title: 'Prueba de alarma de seguridad',
    description: 'Prueba mensual de todas las alarmas de seguridad',
    type: 'security',
    status: 'in_progress',
    priority: 'medium',
    assignedTo: {
      id: 'EMP007',
      name: 'Tomás Anderson'
    },
    assignedBy: {
      id: 'ADM001',
      name: 'Juan Smith'
    },
    dueDate: dayjs('2024-03-20').toDate(),
    workspace: {
      id: 'WS001',
      name: 'Apartamentos Sunset',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'TASK021',
    title: 'Inspeccionar condición del techo',
    description: 'Inspección anual del techo y verificación de mantenimiento',
    type: 'inspection',
    status: 'completed',
    priority: 'urgent',
    assignedTo: {
      id: 'EMP004',
      name: 'Roberto Taylor'
    },
    assignedBy: {
      id: 'ADM002',
      name: 'Lisa Davis'
    },
    dueDate: dayjs('2024-03-17').toDate(),
    completedAt: dayjs('2024-03-17').toDate(),
    workspace: {
      id: 'WS001',
      name: 'Apartamentos Sunset',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'TASK022',
    title: 'Limpiar unidades de almacenamiento',
    description: 'Limpieza mensual del área de unidades de almacenamiento',
    type: 'cleaning',
    status: 'pending',
    priority: 'low',
    assignedTo: {
      id: 'EMP005',
      name: 'María García'
    },
    assignedBy: {
      id: 'ADM001',
      name: 'Juan Smith'
    },
    dueDate: dayjs('2024-03-27').toDate(),
    workspace: {
      id: 'WS001',
      name: 'Apartamentos Sunset',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'TASK023',
    title: 'Reparar fregadero de cocina - Unidad 156',
    description: 'Residente reportó fregadero de cocina obstruido',
    type: 'maintenance',
    status: 'in_progress',
    priority: 'medium',
    assignedTo: {
      id: 'EMP006',
      name: 'Jaime Wilson'
    },
    assignedBy: {
      id: 'ADM002',
      name: 'Lisa Davis'
    },
    dueDate: dayjs('2024-03-21').toDate(),
    apartmentUnit: {
      id: 'UNIT156',
      name: 'Unidad 156'
    },
    workspace: {
      id: 'WS001',
      name: 'Apartamentos Sunset',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'TASK024',
    title: 'Verificar iluminación de seguridad',
    description: 'Verificar toda la iluminación exterior de seguridad',
    type: 'security',
    status: 'completed',
    priority: 'medium',
    assignedTo: {
      id: 'EMP003',
      name: 'David Brown'
    },
    assignedBy: {
      id: 'ADM001',
      name: 'Juan Smith'
    },
    dueDate: dayjs('2024-03-19').toDate(),
    completedAt: dayjs('2024-03-19').toDate(),
    workspace: {
      id: 'WS001',
      name: 'Apartamentos Sunset',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'TASK025',
    title: 'Inspeccionar sistema de alarma contra incendios',
    description: 'Inspección mensual del sistema de alarma contra incendios',
    type: 'inspection',
    status: 'pending',
    priority: 'urgent',
    assignedTo: {
      id: 'EMP004',
      name: 'Roberto Taylor'
    },
    assignedBy: {
      id: 'ADM002',
      name: 'Lisa Davis'
    },
    dueDate: dayjs('2024-03-28').toDate(),
    workspace: {
      id: 'WS001',
      name: 'Apartamentos Sunset',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'TASK026',
    title: 'Limpiar sala de correo',
    description: 'Limpieza diaria del área de la sala de correo',
    type: 'cleaning',
    status: 'completed',
    priority: 'low',
    assignedTo: {
      id: 'EMP002',
      name: 'Sara Wilson'
    },
    assignedBy: {
      id: 'ADM001',
      name: 'Juan Smith'
    },
    dueDate: dayjs('2024-03-19').toDate(),
    completedAt: dayjs('2024-03-19').toDate(),
    workspace: {
      id: 'WS001',
      name: 'Apartamentos Sunset',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'TASK027',
    title: 'Reparar cerradura de puerta - Unidad 223',
    description: 'Residente reportó cerradura de puerta defectuosa',
    type: 'maintenance',
    status: 'pending',
    priority: 'high',
    assignedTo: {
      id: 'EMP001',
      name: 'Miguel Johnson'
    },
    assignedBy: {
      id: 'ADM002',
      name: 'Lisa Davis'
    },
    dueDate: dayjs('2024-03-23').toDate(),
    apartmentUnit: {
      id: 'UNIT223',
      name: 'Unidad 223'
    },
    workspace: {
      id: 'WS001',
      name: 'Apartamentos Sunset',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'TASK028',
    title: 'Instalación de cámara de seguridad',
    description: 'Instalar nuevas cámaras de seguridad en área de estacionamiento',
    type: 'security',
    status: 'in_progress',
    priority: 'high',
    assignedTo: {
      id: 'EMP007',
      name: 'Tomás Anderson'
    },
    assignedBy: {
      id: 'ADM001',
      name: 'Juan Smith'
    },
    dueDate: dayjs('2024-03-25').toDate(),
    workspace: {
      id: 'WS001',
      name: 'Apartamentos Sunset',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'TASK029',
    title: 'Inspeccionar sistemas de calentador de agua',
    description: 'Inspección anual de todos los sistemas de calentador de agua',
    type: 'inspection',
    status: 'completed',
    priority: 'medium',
    assignedTo: {
      id: 'EMP004',
      name: 'Roberto Taylor'
    },
    assignedBy: {
      id: 'ADM002',
      name: 'Lisa Davis'
    },
    dueDate: dayjs('2024-03-16').toDate(),
    completedAt: dayjs('2024-03-16').toDate(),
    workspace: {
      id: 'WS001',
      name: 'Apartamentos Sunset',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'TASK030',
    title: 'Limpiar área de almacenamiento de bicicletas',
    description: 'Limpieza semanal de la instalación de almacenamiento de bicicletas',
    type: 'cleaning',
    status: 'pending',
    priority: 'low',
    assignedTo: {
      id: 'EMP005',
      name: 'María García'
    },
    assignedBy: {
      id: 'ADM001',
      name: 'Juan Smith'
    },
    dueDate: dayjs('2024-03-29').toDate(),
    workspace: {
      id: 'WS001',
      name: 'Apartamentos Sunset',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'TASK031',
    title: 'Reparar triturador de basura - Unidad 189',
    description: 'Residente reportó triturador de basura roto',
    type: 'maintenance',
    status: 'in_progress',
    priority: 'medium',
    assignedTo: {
      id: 'EMP006',
      name: 'Jaime Wilson'
    },
    assignedBy: {
      id: 'ADM002',
      name: 'Lisa Davis'
    },
    dueDate: dayjs('2024-03-22').toDate(),
    apartmentUnit: {
      id: 'UNIT189',
      name: 'Unidad 189'
    },
    workspace: {
      id: 'WS001',
      name: 'Apartamentos Sunset',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'TASK032',
    title: 'Patrulla de seguridad - Edificio B',
    description: 'Patrulla de seguridad nocturna alrededor del Edificio B',
    type: 'security',
    status: 'completed',
    priority: 'high',
    assignedTo: {
      id: 'EMP003',
      name: 'David Brown'
    },
    assignedBy: {
      id: 'ADM001',
      name: 'Juan Smith'
    },
    dueDate: dayjs('2024-03-20').toDate(),
    completedAt: dayjs('2024-03-20').toDate(),
    workspace: {
      id: 'WS001',
      name: 'Apartamentos Sunset',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'TASK033',
    title: 'Inspeccionar sistemas de ventilación',
    description: 'Inspección trimestral de sistemas de ventilación HVAC',
    type: 'inspection',
    status: 'pending',
    priority: 'medium',
    assignedTo: {
      id: 'EMP004',
      name: 'Roberto Taylor'
    },
    assignedBy: {
      id: 'ADM002',
      name: 'Lisa Davis'
    },
    dueDate: dayjs('2024-03-30').toDate(),
    workspace: {
      id: 'WS001',
      name: 'Apartamentos Sunset',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'TASK034',
    title: 'Limpiar área de mascotas',
    description: 'Limpieza diaria del área de ejercicio de mascotas',
    type: 'cleaning',
    status: 'completed',
    priority: 'low',
    assignedTo: {
      id: 'EMP002',
      name: 'Sara Wilson'
    },
    assignedBy: {
      id: 'ADM001',
      name: 'Juan Smith'
    },
    dueDate: dayjs('2024-03-19').toDate(),
    completedAt: dayjs('2024-03-19').toDate(),
    workspace: {
      id: 'WS001',
      name: 'Apartamentos Sunset',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'TASK035',
    title: 'Reparar desagüe de ducha - Unidad 267',
    description: 'Residente reportó ducha de drenaje lento',
    type: 'maintenance',
    status: 'pending',
    priority: 'medium',
    assignedTo: {
      id: 'EMP001',
      name: 'Miguel Johnson'
    },
    assignedBy: {
      id: 'ADM002',
      name: 'Lisa Davis'
    },
    dueDate: dayjs('2024-03-24').toDate(),
    apartmentUnit: {
      id: 'UNIT267',
      name: 'Unidad 267'
    },
    workspace: {
      id: 'WS001',
      name: 'Apartamentos Sunset',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'TASK036',
    title: 'Verificar control de acceso de seguridad',
    description: 'Probar todos los sistemas de control de acceso y tarjetas de llave',
    type: 'security',
    status: 'in_progress',
    priority: 'high',
    assignedTo: {
      id: 'EMP007',
      name: 'Tomás Anderson'
    },
    assignedBy: {
      id: 'ADM001',
      name: 'Juan Smith'
    },
    dueDate: dayjs('2024-03-21').toDate(),
    workspace: {
      id: 'WS001',
      name: 'Apartamentos Sunset',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'TASK037',
    title: 'Inspeccionar salidas de emergencia',
    description: 'Inspección mensual de todas las salidas de emergencia y señalización',
    type: 'inspection',
    status: 'completed',
    priority: 'urgent',
    assignedTo: {
      id: 'EMP004',
      name: 'Roberto Taylor'
    },
    assignedBy: {
      id: 'ADM002',
      name: 'Lisa Davis'
    },
    dueDate: dayjs('2024-03-18').toDate(),
    completedAt: dayjs('2024-03-18').toDate(),
    workspace: {
      id: 'WS001',
      name: 'Apartamentos Sunset',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'TASK038',
    title: 'Limpiar área de techo',
    description: 'Limpieza mensual del área común del techo',
    type: 'cleaning',
    status: 'pending',
    priority: 'low',
    assignedTo: {
      id: 'EMP005',
      name: 'María García'
    },
    assignedBy: {
      id: 'ADM001',
      name: 'Juan Smith'
    },
    dueDate: dayjs('2024-03-31').toDate(),
    workspace: {
      id: 'WS001',
      name: 'Apartamentos Sunset',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'TASK039',
    title: 'Reparar lavavajillas - Unidad 334',
    description: 'Residente reportó lavavajillas que no funciona',
    type: 'maintenance',
    status: 'in_progress',
    priority: 'medium',
    assignedTo: {
      id: 'EMP006',
      name: 'Jaime Wilson'
    },
    assignedBy: {
      id: 'ADM002',
      name: 'Lisa Davis'
    },
    dueDate: dayjs('2024-03-23').toDate(),
    apartmentUnit: {
      id: 'UNIT334',
      name: 'Unidad 334'
    },
    workspace: {
      id: 'WS001',
      name: 'Apartamentos Sunset',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'TASK040',
    title: 'Verificar perímetro de seguridad',
    description: 'Inspección diaria del perímetro de seguridad',
    type: 'security',
    status: 'completed',
    priority: 'high',
    assignedTo: {
      id: 'EMP003',
      name: 'David Brown'
    },
    assignedBy: {
      id: 'ADM001',
      name: 'Juan Smith'
    },
    dueDate: dayjs('2024-03-20').toDate(),
    completedAt: dayjs('2024-03-20').toDate(),
    workspace: {
      id: 'WS001',
      name: 'Apartamentos Sunset',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'TASK041',
    title: 'Inspeccionar detectores de humo',
    description: 'Prueba mensual de todos los detectores de humo',
    type: 'inspection',
    status: 'pending',
    priority: 'urgent',
    assignedTo: {
      id: 'EMP004',
      name: 'Roberto Taylor'
    },
    assignedBy: {
      id: 'ADM002',
      name: 'Lisa Davis'
    },
    dueDate: dayjs('2024-04-01').toDate(),
    workspace: {
      id: 'WS001',
      name: 'Apartamentos Sunset',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'TASK042',
    title: 'Limpiar sala de computadoras',
    description: 'Limpieza semanal de la sala de computadoras del centro de negocios',
    type: 'cleaning',
    status: 'completed',
    priority: 'low',
    assignedTo: {
      id: 'EMP002',
      name: 'Sara Wilson'
    },
    assignedBy: {
      id: 'ADM001',
      name: 'Juan Smith'
    },
    dueDate: dayjs('2024-03-19').toDate(),
    completedAt: dayjs('2024-03-19').toDate(),
    workspace: {
      id: 'WS001',
      name: 'Apartamentos Sunset',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'TASK043',
    title: 'Reparar ventilador de techo - Unidad 445',
    description: 'Residente reportó ventilador de techo haciendo ruido',
    type: 'maintenance',
    status: 'pending',
    priority: 'low',
    assignedTo: {
      id: 'EMP001',
      name: 'Miguel Johnson'
    },
    assignedBy: {
      id: 'ADM002',
      name: 'Lisa Davis'
    },
    dueDate: dayjs('2024-03-25').toDate(),
    apartmentUnit: {
      id: 'UNIT445',
      name: 'Unidad 445'
    },
    workspace: {
      id: 'WS001',
      name: 'Apartamentos Sunset',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'TASK044',
    title: 'Sesión de entrenamiento de seguridad',
    description: 'Sesión mensual de entrenamiento del personal de seguridad',
    type: 'security',
    status: 'in_progress',
    priority: 'medium',
    assignedTo: {
      id: 'EMP007',
      name: 'Tomás Anderson'
    },
    assignedBy: {
      id: 'ADM001',
      name: 'Juan Smith'
    },
    dueDate: dayjs('2024-03-22').toDate(),
    workspace: {
      id: 'WS001',
      name: 'Apartamentos Sunset',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'TASK045',
    title: 'Inspeccionar estructura de estacionamiento',
    description: 'Inspección trimestral de la integridad de la estructura de estacionamiento',
    type: 'inspection',
    status: 'completed',
    priority: 'medium',
    assignedTo: {
      id: 'EMP004',
      name: 'Roberto Taylor'
    },
    assignedBy: {
      id: 'ADM002',
      name: 'Lisa Davis'
    },
    dueDate: dayjs('2024-03-19').toDate(),
    completedAt: dayjs('2024-03-19').toDate(),
    workspace: {
      id: 'WS001',
      name: 'Apartamentos Sunset',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'TASK046',
    title: 'Limpiar sala de conferencias',
    description: 'Limpieza diaria de la sala de conferencias',
    type: 'cleaning',
    status: 'pending',
    priority: 'low',
    assignedTo: {
      id: 'EMP005',
      name: 'María García'
    },
    assignedBy: {
      id: 'ADM001',
      name: 'Juan Smith'
    },
    dueDate: dayjs('2024-04-02').toDate(),
    workspace: {
      id: 'WS001',
      name: 'Apartamentos Sunset',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'TASK047',
    title: 'Reparar buzón de correo - Unidad 512',
    description: 'Residente reportó cerradura de buzón de correo rota',
    type: 'maintenance',
    status: 'in_progress',
    priority: 'medium',
    assignedTo: {
      id: 'EMP006',
      name: 'Jaime Wilson'
    },
    assignedBy: {
      id: 'ADM002',
      name: 'Lisa Davis'
    },
    dueDate: dayjs('2024-03-24').toDate(),
    apartmentUnit: {
      id: 'UNIT512',
      name: 'Unidad 512'
    },
    workspace: {
      id: 'WS001',
      name: 'Apartamentos Sunset',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'TASK048',
    title: 'Revisión de reportes de incidentes de seguridad',
    description: 'Revisión semanal de reportes de incidentes de seguridad',
    type: 'security',
    status: 'completed',
    priority: 'medium',
    assignedTo: {
      id: 'EMP003',
      name: 'David Brown'
    },
    assignedBy: {
      id: 'ADM001',
      name: 'Juan Smith'
    },
    dueDate: dayjs('2024-03-21').toDate(),
    completedAt: dayjs('2024-03-21').toDate(),
    workspace: {
      id: 'WS001',
      name: 'Apartamentos Sunset',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'TASK049',
    title: 'Inspeccionar calidad del agua',
    description: 'Prueba mensual de calidad del agua e inspección',
    type: 'inspection',
    status: 'pending',
    priority: 'urgent',
    assignedTo: {
      id: 'EMP004',
      name: 'Roberto Taylor'
    },
    assignedBy: {
      id: 'ADM002',
      name: 'Lisa Davis'
    },
    dueDate: dayjs('2024-04-03').toDate(),
    workspace: {
      id: 'WS001',
      name: 'Apartamentos Sunset',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'TASK050',
    title: 'Limpiar sala de arte',
    description: 'Limpieza semanal de la sala de arte comunitaria',
    type: 'cleaning',
    status: 'completed',
    priority: 'low',
    assignedTo: {
      id: 'EMP002',
      name: 'Sara Wilson'
    },
    assignedBy: {
      id: 'ADM001',
      name: 'Juan Smith'
    },
    dueDate: dayjs('2024-03-19').toDate(),
    completedAt: dayjs('2024-03-19').toDate(),
    workspace: {
      id: 'WS001',
      name: 'Apartamentos Sunset',
      slug: 'sunset-apartments'
    }
  }
]; 